import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-left: 5em;
  position: relative;
`;
export const Image = styled.img`
  max-width: 208px;
  margin-right: 2em;
`;
export const MainContent = styled.div``;
export const Title = styled.h1`
  font-weight: normal;
  font-size: 2.5rem;
`;
export const Description = styled.p`
  color: #999;
  max-width: 45vw;
  line-height: 200%;
  margin-bottom: 2.5em;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 8em;
  margin-bottom: 5em;
`;

export const DecorationLeft = styled.div`
  height: 220px;
  width: 66.85px;
  background: url("img/talk-to-us-left-decoration.png");
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
`;

export const DecorationRight = styled.div`
  height: 364px;
  width: 74.92px;
  background: url("img/talk-to-us-right-decoration.png");
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 0;
  right: 0;
`;
